/* GP CORPORATE: live display-currency conversion. Actual Shopify checkout currency remains unchanged. */
(function(){
 'use strict';
 const allowed=['BHD','SAR','AED','KWD','QAR','OMR','GBP','EUR','USD'];
 const storageKey='gp_display_currency_preference';
 const rateKey='gp_bhd_fx_rates_v1';
 const interval=18*60*60*1000;
 const priceSelector='bdi[data-gp-price-bhd],bdi[data-gp-price-bhd-min]';
 const originalText=new WeakMap();
 let active='BHD',rateData=null,busy=null,scheduled=false,observer=null;
 const qs=(q,root=document)=>root.querySelector(q);
 const qa=(q,root=document)=>Array.from(root.querySelectorAll(q));
 const chooser=()=>qs('[data-gp-currency-select]');
 const modal=()=>qs('[data-gp-currency-modal]');
 const status=()=>qs('[data-gp-currency-result]');
 const report=(str,isError)=>{
  const el=status();
  if(el){el.textContent=str;el.dataset.state=isError?'error':'ok'}
 };
 function getSaved(){
  try{const x=localStorage.getItem(storageKey)||'BHD';return allowed.includes(x)?x:'BHD'}catch(e){return 'BHD'}
 }
 function save(code){try{localStorage.setItem(storageKey,code)}catch(e){}}
 function parseMajor(value){
  if(typeof value==='number')return value;
  let s=String(value||'').replace(/[^\d.,-]/g,'');
  if(!s)return NaN;
  const lastDot=s.lastIndexOf('.');
  const lastComma=s.lastIndexOf(',');
  if(lastDot>=0&&lastComma>=0){
   const dec=lastDot>lastComma?'.':',';
   const group=dec==='.'?',':'.';
   s=s.split(group).join('');
   if(dec===',')s=s.replace(',','.');
  }else if(lastComma>=0){
   // Shopify's BHD money_without_currency is normally 3 fractional digits with period.
   // Single comma separated three digits is interpreted as a thousands group.
   const tail=s.length-lastComma-1;
   s=tail===2?s.replace(',','.') : s.replace(/,/g,'');
  }else{
   const dots=(s.match(/\./g)||[]).length;
   if(dots>1){const j=s.lastIndexOf('.');s=s.slice(0,j).replace(/\./g,'')+s.slice(j)}
  }
  const n=Number(s);
  return Number.isFinite(n)?n:NaN;
 }
 function formatMoney(amount,code){
  const digits=['BHD','KWD','OMR'].includes(code)?3:2;
  return code+' '+new Intl.NumberFormat('en-US',{minimumFractionDigits:digits,maximumFractionDigits:digits}).format(amount);
 }
 function setHeader(code){
  qa('[data-gp-displayed-currency]').forEach(el=>el.textContent=code);
  const selected=chooser();if(selected)selected.value=code;
  document.documentElement.dataset.gpDisplayCurrency=code;
 }
 function cacheRead(){
  try{
   const c=JSON.parse(sessionStorage.getItem(rateKey)||localStorage.getItem(rateKey)||'null');
   if(c&&c.date&&c.timestamp&&Date.now()-c.timestamp<interval&&c.rates&&Number(c.rates.USD)>0){
    return c;
   }
  }catch(e){}
  return null;
 }
 function cacheWrite(c){
  try{sessionStorage.setItem(rateKey,JSON.stringify(c))}catch(e){}
  try{localStorage.setItem(rateKey,JSON.stringify(c))}catch(e){}
 }
 async function getRates(){
  if(rateData&&Number(rateData.rates.USD)>0)return rateData;
  rateData=cacheRead();if(rateData)return rateData;
  if(busy)return busy;
  busy=(async()=>{
    const urls=[
     'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/bhd.min.json',
     'https://latest.currency-api.pages.dev/v1/currencies/bhd.min.json'
    ];
    let error=null;
    for(const url of urls){
     try{
      const abort=new AbortController();
      const timer=setTimeout(()=>abort.abort(),9500);
      let response;
      try{response=await fetch(url,{mode:'cors',signal:abort.signal,cache:'no-cache'})}
      finally{clearTimeout(timer)}
      if(!response.ok)throw new Error('FX source unavailable');
      const d=await response.json(),rates=d.bhd||{};
      const needed=['sar','aed','kwd','qar','omr','gbp','eur','usd'];
      if(!needed.every(x=>Number(rates[x])>0))throw new Error('Incomplete currency list');
      const normalized={BHD:1};for(const c of needed)normalized[c.toUpperCase()]=Number(rates[c]);
      const data={date:String(d.date||'not specified'),timestamp:Date.now(),rates:normalized};
      cacheWrite(data);rateData=data;
      return data;
     }catch(e){error=e}
    }
    throw error||new Error('Could not retrieve currency rates');
  })();
  try{return await busy}finally{busy=null}
 }
 function convertText(el){
  if(!originalText.has(el))originalText.set(el,el.textContent);
  if(active==='BHD'){
    const original=originalText.get(el);
    if(el.textContent!==original)el.textContent=original;
    el.removeAttribute('data-gp-converted');
    return;
  }
  const rate=Number(rateData?.rates?.[active]);
  if(!(rate>0))return;
  let text='';
  if(el.dataset.gpPriceBhdMin!=null){
   const lo=parseMajor(el.dataset.gpPriceBhdMin);
   const hi=parseMajor(el.dataset.gpPriceBhdMax);
   if(!Number.isFinite(lo)||!Number.isFinite(hi))return;
   text=formatMoney(lo*rate,active)+' – '+formatMoney(hi*rate,active);
  }else{
   const amount=parseMajor(el.dataset.gpPriceBhd);
   if(!Number.isFinite(amount))return;
   text=formatMoney(amount*rate,active);
  }
  if(text&&el.textContent!==text)el.textContent=text;
  el.dataset.gpConverted=active;
 }
 function convertAll(){
  qa(priceSelector).forEach(convertText);
  // Product suggestions from Shopify's Ajax API use 100 monetary subunits per base unit.
  qa('[data-gp-price-ajax-minor]').forEach(el=>{
   if(!originalText.has(el))originalText.set(el,el.textContent);
   if(active==='BHD'){if(el.textContent!==originalText.get(el))el.textContent=originalText.get(el);return}
   const cents=Number(el.dataset.gpPriceAjaxMinor),rate=rateData?.rates?.[active];
   if(Number.isFinite(cents)&&Number(rate)>0){
    const text=formatMoney(cents/100*rate,active);
    if(el.textContent!==text)el.textContent=text;
   }
  });
 }
 function scheduleRender(){
  if(scheduled)return;scheduled=true;
  requestAnimationFrame(()=>{scheduled=false;convertAll()});
 }
 async function apply(code,fromUser){
  if(!allowed.includes(code)){report('Unsupported currency. Please choose another option.',true);return false}
  if(code==='BHD'){
   active='BHD';rateData=null;save('BHD');setHeader('BHD');scheduleRender();
   report('Showing original BHD prices. Checkout currency is BHD.',false);
   return true;
  }
  report('Getting the latest exchange rate and updating product prices…',false);
  const btn=qs('[data-gp-currency-apply]');
  if(btn)btn.disabled=true;
  try{
   const data=await getRates();
   if(!(Number(data.rates[code])>0))throw new Error('Currency rate not available');
   active=code;save(code);setHeader(code);scheduleRender();
   report('Prices converted to '+code+' using rates dated '+data.date+'. Estimates only; checkout may still charge BHD.',false);
   if(fromUser){const ov=modal();if(ov){ov.hidden=true;ov.setAttribute('aria-hidden','true')}}
   return true;
  }catch(e){
   if(fromUser)report('Could not load live exchange rates. Product prices remain in '+active+'. Please try again.',true);
   setHeader(active);
   return false;
  }finally{if(btn)btn.disabled=false}
 }
 function open(){
  const ov=modal(),sel=chooser();if(!ov)return;
  ov.hidden=false;ov.setAttribute('aria-hidden','false');
  if(sel){sel.value=active;sel.focus()}
 }
 function close(){const ov=modal();if(ov){ov.hidden=true;ov.setAttribute('aria-hidden','true')}}
 function init(){
  const ov=modal(),sel=chooser();if(!ov||!sel)return;
  setHeader('BHD');
  qa('[data-gp-open-currency]').forEach(el=>el.addEventListener('click',open));
  qa('[data-gp-currency-close]',ov).forEach(el=>el.addEventListener('click',close));
  ov.addEventListener('click',e=>{if(e.target===ov)close()});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!ov.hidden)close()});
  qs('[data-gp-currency-apply]',ov)?.addEventListener('click',()=>apply(sel.value,true));
  sel.addEventListener('change',()=>report('Click Apply display currency to update prices throughout the page.',false));
  observer=new MutationObserver(mutations=>{
   if(mutations.some(m=>m.target.closest?.('[data-gp-price-bhd]') || m.target.closest?.('product-price') || Array.from(m.addedNodes||[]).some(n=>n.nodeType===1&&(n.matches?.(priceSelector)||n.querySelector?.(priceSelector)))))scheduleRender();
  });
  observer.observe(document.body,{subtree:true,childList:true});
  const saved=getSaved();
  if(saved!=='BHD')apply(saved,false);else{scheduleRender();report('Showing original BHD prices. Checkout currency is BHD.',false)}
  // When a shopper changes their delivery country, recommend its display currency.
  const intent=(()=>{try{const q=sessionStorage.getItem('gp_currency_requested');if(q)sessionStorage.removeItem('gp_currency_requested');return q}catch(e){return null}})();
  if(intent&&allowed.includes(intent)&&intent!==getSaved())apply(intent,false);
 }
 window.GPCurrency={
  current:()=>active,
  formatFromMinor:function(cents){
   const amount=Number(cents)/100;
   const rate=active==='BHD'?1:rateData?.rates?.[active];
   return Number.isFinite(amount)&&Number(rate)>0?formatMoney(amount*rate,active):formatMoney(amount,'BHD');
  },
  refresh:scheduleRender
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();